"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LocationNotificationActions;
(function (LocationNotificationActions) {
    LocationNotificationActions["CREATE"] = "location_create";
    LocationNotificationActions["UPDATE"] = "location_update";
})(LocationNotificationActions = exports.LocationNotificationActions || (exports.LocationNotificationActions = {}));
exports.countryCalendars = 'countryCalendars';
//# sourceMappingURL=location.js.map